import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';
import { renderText } from './assistent/assistent_helpers';

export interface DateneingabeBetrieblicheDatenKennzahlenProps {
    data: any;
    directAddFormular?: boolean;
    parentElement?: String;
    onChange?: () => void;
    onClose?: () => void;
}

export class DateneingabeBetrieblicheDatenKennzahlen extends React.Component<DateneingabeBetrieblicheDatenKennzahlenProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
        this.validateField = this.validateField.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    cleanString(value: string) {
        value = value.toLowerCase();
        value = value.replace(/ä/g, 'ae');
        value = value.replace(/ö/g, 'oe');
        value = value.replace(/ü/g, 'ue');
        value = value.replace(/ß/g, 'ss');
        value = value.replace(/ /g, '-');
        value = value.replace('.', '');
        value = value.replace(',', '');
        value = value.replace('(', '');
        value = value.replace(')', '');
        value = value.replace('&', '');
        value = value.replace('%', '');
        value = value.replace('\\', '');
        value = value.replace('/', '');
        value = value.replace('$', '');
        value = value.replace('[', '');
        value = value.replace(']', '');
        value = value.replace('!', '');
        value = value.replace('?', '');
        value = value.replace(' ', '');
        return value;
    }
    render(): JSX.Element {
        const { data, directAddFormular, onClose, onChange, parentElement } = this.props;
        // const externalDescription = <span>Dies ist ein Beschreibungstext, der noch definiert werden muss!</span>;
        const externalDescription = <div style={{ marginLeft: 11 }}>
            {renderText('Betriebliche Daten - Kennzahlen Formular', data)}
        </div>;
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_KENNZAHLEN_DYNAMISCH}
                    module={IDs.MOD_ETOOL}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    directAddFormular={directAddFormular}
                    addLabel={'Kennzahl erfassen'}
                    validateField={this.validateField}
                    onAfterAction={(action: string) => {
                        if (parentElement === 'KennzahlenButtonWrapper') {
                            if (directAddFormular) {
                                if (action === 'closeFormAdd') {
                                    if (onClose) {
                                        onClose();
                                    }
                                }
                                if (action === 'saveDone') {
                                    this.triggerService.fire('reload', IDs.ENT_KENNZAHLEN_DYNAMISCH, () => {
                                        if (onChange) {
                                            onChange();
                                        }
                                    });
                                }
                            }
                        } else {
                            if (action === 'saveDone' || action === 'delDone') {
                                this.triggerService.fire('reload', IDs.ENT_KENNZAHLEN_DYNAMISCH, () => {
                                    if (this.props.onChange) {
                                        this.props.onChange();
                                    }
                                });
                            }
                        }
                    }}
                    externalFormDescriptionElement={externalDescription}
                />
            </div>
        );
    }

    validateField?(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void) {
        if (key === 'name' && value) {
            const kuerzel = this.cleanString(value);
            const kuerzel_old = data.getValue('kuerzel');
            const tid = data.getValue('tid');
            if (+tid > 0) {
                // console.log('KUER - NOT setting');
                return;
            }
            // console.log('KUER', value, kuerzel, data);
            if (!kuerzel_old || kuerzel_old !== kuerzel) {
                //  console.log('KUER - setting');
                onValueChange('kuerzel', kuerzel);
            }

        }

        return '';
    }
}
